module.exports = __webpack_public_path__ + "static/masonry-image-2-49e22f2f2f1fd9171b619bf34396e4e2.jpg";